export const isValidEmail = async (email) => {
  const {freeDomains} = await fetch('/free-domains.json').then(async (r) => await r.json())
  if (typeof email === 'string') {
    if (/^\S+@\S+\.\S+$/.test(email)) {
      const [, domain] = email.split('@')
      if (!freeDomains.includes(domain)) {
        return true
      }
    }
  }

  return false
}
